'use strict';

/** @module FontSizes
 */
module.exports = [10, 12, 14, 16, 18, 21, 24, 36, 40, 48, 60, 64, 72, 104];
